import {TStates, stateCities} from './cities';


export abstract class AppConstants {
	static readonly allStates: TStates[] = stateCities;
}

//
// const SEX = {
// 	Male: 0,
// 	Female: 1,
// } as const;
//
// type Sex = typeof SEX[keyof typeof SEX];
